import trackPerformance from '@carvana/eventable-web-vitals';

const PROJECT = 'carvana-value-tracker-ui';
const TRACK = 'stc';

const initializeWebVitals = (): void => {
  try {
    trackPerformance({
      environment: process.env.CARVANA_APP_ENVIRONMENT ?? '',
      project: PROJECT,
      track: TRACK,
      payloadMetaAttributes: { version: process.env.APP_VERSION ?? '' }
    });
  } catch {
    // Web vitals is best-effort; never break the app
  }
};

export { initializeWebVitals };
